import type { GetWebcastSummaryManagerQuery } from '../../../../../../generated/graphql-manager';

import { FolderIcon, Paragraph, Tooltip, classNames } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import { getWebcastTitle } from '../../../../../hooks/use-get-webcast-name';
import { DownloadRecording } from '../download-recording/download-recording';

import styles from './event-summary-recording.module.css';

type EventSummaryRecordingProps = {
  webcast: GetWebcastSummaryManagerQuery['webcast'];
  language: string;
  multipleLanguages?: boolean;
};

export function EventSummaryRecording({ webcast, language, multipleLanguages }: EventSummaryRecordingProps) {
  const { t } = useTranslation();

  const recordings = webcast?.streaming?.recordings;
  const contents = webcast?.contents || [];

  const videoManager = webcast?.recordingSettings?.videoManager;
  const uploadChannels = videoManager?.channels;
  const uploadToVmProEnabled = videoManager?.enabled && uploadChannels && uploadChannels.length > 0;

  return (
    <div key={language} className={styles.container}>
      <div className={styles.eventRecordingContent}>
        <Tooltip label={getWebcastTitle(language, contents)}>
          <Paragraph data-testid={`recording-title-${language}`} className={styles.textEllipsis}>
            {getWebcastTitle(language, contents)}
          </Paragraph>
        </Tooltip>

        {uploadToVmProEnabled &&
          uploadChannels?.map((channel) => (
            <div key={channel.name} className={styles.uploadPathWrapper}>
              <Tooltip label={t('manager.eventSummary.recording.recordingPathHint')}>
                <FolderIcon />
              </Tooltip>
              <Tooltip label={channel.name}>
                <Paragraph
                  data-testid={`recording-channel-${channel.name}`}
                  className={classNames(styles.uploadPath, styles.textEllipsis)}
                >
                  {channel.name}
                </Paragraph>
              </Tooltip>
            </div>
          ))}
      </div>

      <div>
        <DownloadRecording
          className={styles.downloadRecordingButton}
          label={t('manager.eventSummary.recording.downloadButton')}
          recording={recordings?.find((recording) => recording.metadata.language === language)}
          webcastId={webcast.id}
          webcastTitle={getWebcastTitle(language, contents) || ''}
          language={language}
          multipleLanguages={multipleLanguages}
        />
      </div>
    </div>
  );
}
